import React, { useLayoutEffect } from 'react'
import { NavLink } from 'react-router-dom'
import NavItem from '../NavItem/NavItem'
import propTypes from 'prop-types'
import { useOutsideClick } from '../../../../hooks/useOutsideClick'
import { useBp } from '../../../../utils/Breakpoints/Breakpoints'
import Menu from '../../Menu/Menu'

import './MenuNav.scss'

const MenuNav = ({ menuOpen, setMenuOpen }) => {
  const handleClickOutside = () => {
    setMenuOpen(false)
  }
  const menuRef = useOutsideClick(
    (e, ref) =>
      ref.current &&
      !ref.current.contains(e.target) &&
      !e.target.matches('.close-btn'),
    handleClickOutside
  )

  // Close menu state above xs breakpoint
  const aboveXs = useBp('> xs')
  useLayoutEffect(() => {
    setMenuOpen(false)
  }, [aboveXs, setMenuOpen])

  return (
    <nav className='menu-nav' ref={menuRef}>
      <NavItem
        id={menuOpen ? 'close' : 'menu'}
        type='icon'
        text={`${menuOpen ? 'Close' : 'Open'} menu`}
        action={() => {
          setMenuOpen(!menuOpen)
        }}
        icon={{
          name: menuOpen ? 'xmark' : 'bars',
          alt: `${menuOpen ? 'Close' : 'Open'} menu`,
          size: menuOpen ? 20 : 16,
        }}
      />
      <Menu
        trigger={{ name: 'menuNav', value: menuOpen }}
        scope={{ ref: menuRef, class: '.menu-nav' }}>
        <NavLink
          className='btn nav-btn'
          to='/work'
          draggable='false'
          onClick={() => {
            setMenuOpen(false)
          }}>
          Work
        </NavLink>
        <NavLink
          className='btn nav-btn'
          to='/about'
          draggable='false'
          onClick={() => {
            setMenuOpen(false)
          }}>
          About
        </NavLink>
      </Menu>
    </nav>
  )
}

MenuNav.propTypes = {
  menuOpen: propTypes.bool.isRequired,
  setMenuOpen: propTypes.func.isRequired,
}

export default MenuNav
